import type { HomeStatus } from "@components/HomePage/TopMenu/homeStatus";
import { tui } from "../locale";
import { useOnlyReloading, useToolsEnabled, useToolsLoading } from "../store/useWorkspaceToolsStore";
import { useAfterDelay } from "./useAfterDelay";
import { useUpdateFailure } from "./useUnseenError";

/** A workspace switch loads the tools in well under this; the status is for the load that does not end soon. */
export const LOADING_STATUS_DELAY_MS = 1000;

export const useWorkspaceToolsStatus = (): HomeStatus | null => {
	const enabled = useToolsEnabled();
	const loading = useToolsLoading();
	// A reload is asked for by the user, who wants to see it run at once.
	const onlyReloading = useOnlyReloading();
	const showLoading = useAfterDelay(loading, onlyReloading ? 0 : LOADING_STATUS_DELAY_MS);
	const failure = useUpdateFailure();

	if (!enabled) return null;
	if (showLoading) return { kind: "loading", title: tui(onlyReloading ? "reload.in-progress" : "loading") };
	if (!failure || loading) return null;

	const code = failure.code ?? "other";
	return {
		kind: "warning",
		title: tui("update-failed"),
		text: `${tui(`update-failed.${code}`)} ${tui("update-failed.shown")}`,
		hint: tui(`update-failed.action.${code}`),
	};
};
